import React from 'react';
import SortingList from './SortingList';

const SortingPanel = (props) => {
  return <SortingList {...props} />;
};

export default SortingPanel;
